// extracted by mini-css-extract-plugin
export var productImage = "_zz-0";